import { GET_SPECIFIC_PROJECT_TYPES } from '../actions/types';

const specificProjectTypes = (state = {}, action) => {
  switch (action.type) {
    case GET_SPECIFIC_PROJECT_TYPES:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default specificProjectTypes;